import { CROP_LOGO, TOGGLE_CROPPER_MODAL } from '@/constants';

export const cropLogo = (logo) => ({ type: CROP_LOGO, logo });
export const toggleCropperModal = (open) => ({
    type: TOGGLE_CROPPER_MODAL,
    open
});
